import { render } from "./IngresoComponent.vue?vue&type=template&id=1effbcbe"
import script from "./IngresoComponent.vue?vue&type=script&lang=js"
export * from "./IngresoComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/circleci/repo/pwa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__